const regex = /^\/+[A-Z0-9+-.]{7}$/;
const getMessage = () => `手機條碼載具格式錯誤`;
const validate = (value) => regex.test(value);

/** 自訂驗證 手機號碼載具 格式 */
export default {
  getMessage,
  validate,
};
